import { Button } from "@mui/material";
import { motion } from "framer-motion";
import React, { memo, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AnimatedLetter from "../../AnimatedLetters";
import "./index.scss";

const Home = () => {
  const nameStr = " Taifur";
  const skillStr = "Web Developer";
  const nameArray = nameStr.split("");
  const skillArray = skillStr.split("");

  const [letterClass, setLetterClass] = useState("text-animate");

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 4000);
  }, []);

  const ferriosOftech = [
    "bootstrap-5-1.svg",
    "framer-motion.svg",
    "git-icon.svg",
    "javascript-1.svg",
    "mongodb-icon-1.svg",
    "mysql-3.svg",
    "next-js.svg",
    "nodejs-2.svg",
    "react-2.svg",
    "sass-1.svg",
    "socket-io-1.svg",
    "tailwindcss.svg",
    "typescript.svg",
  ];

  return (
    <div className="home__page">
      <div className="content">
        <div className="text__zone">
          <h1>
            <span className={letterClass}>H</span>
            <span className={`${letterClass} _12`}>e</span>
            <span className={`${letterClass} _13`}>l</span>
            <span className={`${letterClass} _14`}>l</span>
            <span className={`${letterClass} _15`}>o,</span>
            <br />
            <span className={`${letterClass} _16`}>I</span>
            <span className={`${letterClass} _17`}>'m</span>
            <AnimatedLetter
              letterClass={letterClass}
              strArray={nameArray}
              idx={15}
            />
            <br />
            <AnimatedLetter
              letterClass={letterClass}
              strArray={skillArray}
              idx={22}
            />
          </h1>

          <h2>Full Stack Developer / JavaScript Expart</h2>
          <div className="home__contact__btn">
            <Link to="/contact">
              <Button className="contact-btn">Contact Me</Button>
            </Link>
          </div>
        </div>

        <div className="ferris-container">
          {ferriosOftech.map((tech, index) => {
            return (
              <motion.div
                className="ferris"
                key={index + 1}
                initial="initial"
                animate={["animate", "initialHide"]}
                variants={{
                  initial: {
                    opacity: 0,
                  },
                  initialHide: {
                    opacity: 1,
                    transition: {
                      delay: index + 1,
                    },
                  },
                  animate: {
                    rotate: -360,
                    transition: {
                      duration: ferriosOftech.length,
                      repeat: Infinity,
                      delay: index + 1,
                      ease: "linear",
                    },
                  },
                }}
              >
                <div className="img-parent">
                  <img
                    src={require(`./techIcon/${tech}`)}
                    alt={tech}
                    className="tech-icon"
                  />
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default memo(Home);
